// extracted by mini-css-extract-plugin
export default {"container":"AccountLink_container__GbILE"};